<template>

    <div id="skills_tab" class="flex_content">
        <div class="container data_table_view">
            <div v-if="dataLoaded">

                <TableWrapper tableContainerId="positions_table_container" v-if="currentRef" class="with_shadow">

                    <template v-slot:tableHead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th :class="activeSortingClass('candidate_username')"
                                class="sortable_column eval_username"
                                data-tooltip="Score de matching"
                                @click="reorderEval('candidate_username')">
                                {{ $t('modules.positions.evals_detail.candidates') }}
                            </th>
                            <th :class="activeSortingClass('completed_date')"
                                class="sortable_column"
                                data-tooltip="Score de matching"
                                @click="reorderEval('completed_date')">
                                {{ $t('modules.positions.evals_detail.completed_date') }}
                            </th>
                            <th :class="activeSortingClass('created_at')"
                                class="sortable_column"
                                data-tooltip="Score de matching"
                                @click="reorderEval('created_at')">
                                {{ $t('modules.positions.evals_detail.created_at') }}
                            </th>
                            <th>
                                {{ $t('modules.positions.evals_detail.documents') }}
                            </th>
                        </tr>
                    </template>

                    <template v-slot:tableBody>

                        <tr class="evalution_item_name"
                            v-for="(evaluation, index) in evaluations"
                            :index="index" :key="evaluation.id" >

                            <td>
                                <!-- <TableSelectCheckbox :checkboxId=" 'select_' + evaluation.id"
                                    v-if="evaluation.completed"
                                    @change="checkSelectedEval($event, evaluation.id)"
                                    :isChecked="isSelected(evaluation.id)" />-->
                            </td>

                            <td><completedMark :evaluation="evaluation" /></td>


                            <td class="eval_username">
                                <router-link :to=" '/evaluations/' + evaluation.id ">
                                    {{ evaluation.candidate_username }}
                                </router-link>
                            </td>


                            <td>{{ completedAt(evaluation) }} </td>
                            <td>{{ createdAt(evaluation) }} </td>

                            <td>
                                <ReportsDropDown
                                    :doc_files="evaluation.docs_ids"
                                    :expert_report_url="evaluation.saven_test.expert_report_url"
                                    :passeport_report_url="evaluation.saven_test.passeport_report_url"
                                    :customer_report_url="evaluation.saven_test.customer_report_url"
                                    @deleteFileClicked="deleteFileFromEval"/>
                            </td>
                        </tr>

                    </template>

                </TableWrapper>

            </div>
        </div>
    </div>

</template>

<script>
    import ReportsDropDown from '@/modules/evaluations/components/index/reportsDropDown'



    export default {
        name: 'PostitionEvalsGeneralTab',
        props: ["evaluations", "currentPosition", "currentRef", "dataLoaded"],
        components: {
            ReportsDropDown
        },
        data(){
            return {
                current_sorting: null
            }
        },
        computed: {},
        methods: {
            isSelected(evaluationId){
                return this.$store.state.PositionStore.SelectedPositionEvalsIds.includes(evaluationId)
            },
            checkSelectedEval(isChecked, evaluationId){
                this.$emit("SelectionCheckBoxClicked",{isChecked: isChecked, evaluationId: evaluationId} )
            },
            reorderEval(key){
                this.current_sorting = key
                this.$emit('reorderEval', key)
            },
            activeSortingClass(key){
                if (key  == this.current_sorting){
                    return 'active'
                }else{
                    return ''
                }
            },
            createdAt(evaluation){
                return this.$date(evaluation.created_at, "YYYY-MM-DD HH:mm:ss").locale(this.$i18n.locale).fromNow()
            },
            completedAt(evaluation){
                if (evaluation.completed){
                    return this.$date(evaluation.completed_date, "YYYY-MM-DD HH:mm:ss").locale(this.$i18n.locale).fromNow()
                }else{
                    return "-"
                }
            },
            deleteFileFromEval(file, evaluation){
                // const evalFiles = JSON.parse(JSON.stringify(evaluation.docs_ids))
                // this._.remove(evalFiles, function(evalFile){
                //     return evalFile.file_id == file.file_id
                // });
                // this.$store.dispatch('EvalStore/saveEval', {id: evaluation.id, docs_ids: evalFiles})
            }
        }
    }
</script>

<style lang="scss" scoped>
th{
    text-align: center!important;
    user-select: none;
}
.sortable_column{
    cursor: pointer;
}
th.active{
    background: #d2ddea;
}
td{
    text-align: center;
    color: #8f9aaa;
    height: 40px!important;
    padding-top: 6px!important;
    padding-bottom: 6px!important;

}

.data_table_view {
    padding-top: 50px;
}
.eval_username{
    text-align: left!important;
}
td.eval_username{
    text-align: left!important;
    font-weight: 500;
}
</style>
